import { createCollectCoordinator } from './collect-coordinator';
import { collectFingerprint } from './fingerprint';
import { installGlobals } from './globals';
import { readCollectionId, readDeviceUuid, writeCollectionId } from './storage';
import { readSnapshot } from './snapshot';
import { createTransport } from './transport';
import { hookHistory } from './url-tracker';
import { SDK_VERSION } from './version';

export type BootOptions = {
  publishableKey: string;
  baseUrl: string;
  debug: boolean;
};

export async function bootSdk(opts: BootOptions): Promise<void> {
  const transport = createTransport({ ...opts, sdkVersion: SDK_VERSION });
  installGlobals();

  const coordinator = createCollectCoordinator({
    deviceUuid: readDeviceUuid(),
    getCollectionId: () => readCollectionId(),
    setCollectionId: (cid) => writeCollectionId(cid),
    transport,
    readSnapshot: () => readSnapshot(),
    collectFingerprint,
    sdkVersion: SDK_VERSION,
  });

  coordinator.trigger('boot');

  hookHistory({
    getCurrentUrl: () => location.href,
    onUrlChange: () => coordinator.trigger('url_change'),
  });

  window.addEventListener('resize', () => coordinator.triggerViewportChange());
  window.visualViewport?.addEventListener('resize', () => coordinator.triggerViewportChange());
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      coordinator.triggerVisibilityResume();
    }
  });
}
